export const EXCMDAILYPLANITEM_CREATE_RESET = 'EXCMDAILYPLANITEM_CREATE_RESET'
export const EXCMDAILYPLANITEM_CREATE_SET_CREATED = 'EXCMDAILYPLANITEM_CREATE_SET_CREATED'
export const EXCMDAILYPLANITEM_CREATE_SET_ERROR = 'EXCMDAILYPLANITEM_CREATE_SET_ERROR'
export const EXCMDAILYPLANITEM_CREATE_SET_VIOLATIONS = 'EXCMDAILYPLANITEM_CREATE_SET_VIOLATIONS'
export const EXCMDAILYPLANITEM_CREATE_TOGGLE_LOADING = 'EXCMDAILYPLANITEM_CREATE_TOGGLE_LOADING'
